var isLocalStorageSupport = true;
jQuery(function($) {
	if(typeof(Storage) !== "undefined") {
		isLocalStorageSupport = true;
	} else {
		isLocalStorageSupport = false;
		// Sorry! No Web Storage support..
	}
	custom_scrollable_hover();
    amendEspotContent();
    setUrlInSession();
    overAllSiteHeaderFunctions();
    overAllSiteFooterFunctions();
    categoryListing();
    sliderRightMenu();
    bindEvents();
    optionchange();
    compareAndQuickView();
    checkGiftCardErrors();
    checkRoxErrors();
    checkSupernovaError();
    checkRoxRemixErrors();
    checkZeroPowerError();
    checkRoxRemixCaseItemerror();
    checkPreorderErrors();
    checkElectronicsErrors();
    checkCountdownEnd();
    triggerRedLabel();
    remove_freeMessage();
    processCookieCartItemsForWCS();
    initNavigation();
    headerFunctions();
    sidebarHideFavEmptyDiv();
    openLinksInNewTab();
    californiaWarning();
    egiftcard();
    lifecodeIframeheight();
    checkBOPSCartMergeErrors();
	checkSFSLoginRedirectErrors();
    
    if($('body').hasClass('wcs-en_US')){
    	if($('#D_Cart_Top_ShopRunner').length === 0){
    		window.shoprunnerUpdateContent();
    	}
	}
});

$(window).load(function() {
    setTimeout(function(){
    	$('button#addCartButton').unbind("click").bind("click", function (){ 
            clearSessionStorage(); 
    	});
    },2000);
	wcs_paypal_overlay();
});
